const SUBJECT_ICON_MAP = {
    '수학': '📐', '영어': '🔤', '국어': '📚', '물리': '⚛️',
    '화학': '🧪', '생물': '🧬', '역사': '🏛️', '사회': '🌍',
    '프로그래밍': '💻', '음악': '🎵', '미술': '🎨', '체육': '⚽',
    '과학': '🔬', '지리': '🗺️', '경제': '💰', '철학': '🤔',
    'Math': '📐', 'English': '🔤', 'Science': '🔬', 'History': '🏛️',
    'Physics': '⚛️', 'Chemistry': '🧪', 'Biology': '🧬',
    'Programming': '💻', 'Music': '🎵', 'Art': '🎨',
    '기타': '📖'
};

export const getSubjectIcon = (name) => {
    if (!name) return '📖';
    // 정확한 매칭
    if (SUBJECT_ICON_MAP[name]) return SUBJECT_ICON_MAP[name];
    // 부분 매칭
    const lowerName = name.toLowerCase();
    for (const [key, icon] of Object.entries(SUBJECT_ICON_MAP)) {
        if (lowerName.includes(key.toLowerCase()) || key.toLowerCase().includes(lowerName)) {
            return icon;
        }
    }
    return '📖';
};

export default SUBJECT_ICON_MAP;
